import { ICPData } from '../PartnerIQ/reducer'

export enum IcpActionTypes {
  SET_ALL_ICP_DATA = 'SET_ALL_ICP_DATA',
  UPDATE_ICP = 'UPDATE_ICP',
}

export type AllIcpPayload = {
  total: number
  icps: ICPData[] | null
}

export const setAllIcpData = (data: AllIcpPayload) => ({
  type: IcpActionTypes.SET_ALL_ICP_DATA,
  payload: data,
})

export const updateIcpInList = (icpId: string, updates: Partial<ICPData>) => ({
  type: IcpActionTypes.UPDATE_ICP,
  payload: { icpId, updates },
})
